var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imageData && _vm.imageData.src)?_c('img',{attrs:{"src":_vm.imageData.src}}):_c('canvas',{ref:"canvas",staticClass:"fd-draw-module",class:{'ready': _vm.isRendered},attrs:{"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }